import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class KycServiceService {

  private baseUrl = environment.apiUrl;
  isLoading = false;
  constructor(private http: HttpClient,
    private loader: NgxSpinnerService,
    private toaster: ToastrService,
  ) { }

  getBusinessTypes() {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-business-type`
    );
  }

  storeBusinessType(body: any) {
    return this.http.post(
      `${this.baseUrl}/customer/kyc/store-business-type`, body
    );
  }

  getSelectedBusinessType() {
    return this.http.get(
      `${this.baseUrl}/customer/kyc/get-business-type`
    );
  }


  getCompanyType() {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-company-type`
    );
  }
  getDucumentType(selectedKycType: any) {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-document-type?business_type_id=${selectedKycType}`
    );
  }

  storeKycIdProof(body: any) {
    return this.http.post(
      `${this.baseUrl}/customer/personal/store-id-proof`, body
    );
  }

  getKycIdProof(selectedKycType: any) {
    return this.http.get(
      `${this.baseUrl}/customer/personal/get-id-proof?business_type_id=${selectedKycType}`
    );
  }
  storeBusinessKyc(body: any) {
    return this.http.post(
      `${this.baseUrl}/customer/business/store-commercial-kyc`, body
    );
  }

  getBusinessKyc() {
    return this.http.get(
      `${this.baseUrl}/customer/business/get-commercial-kyc`
    );
  }
  storeAddressKyc(body: any) {
    return this.http.post(
      `${this.baseUrl}/customer/personal/store-address`, body
    );
  }

  getAddressKyc() {
    return this.http.get(
      `${this.baseUrl}/customer/personal/get-address`
    );
  }

  finalizeStepforKyc(body: any) {
    return this.http.post(
      `${this.baseUrl}/customer/kyc/terms-accepted`, body
    );
  }

  getPincodeData(pincode: any) {
    return this.http.get(
      `${this.baseUrl}/customer/master/get-pincode-wise-data?pincode=${pincode}`
    );
  }

  getKycProfile() {
    return this.http.get(
      `${this.baseUrl}/customer/kyc/kyc-profile`

    );
  }
  getDocumentImage(body: any) {
    return this.http.post(`${this.baseUrl}/customer/kyc/show-documents-image `, body);
  }

  changePassword(body: any) {
    return this.http.post(`${this.baseUrl}/customer/change-password `, body);

  }

 
  private readonly PROFILE_KEY = 'KYC_PROFILE_DATA';

  private profileSubject = new BehaviorSubject<any>(null);

  profile$ = this.profileSubject.asObservable();

  private getStoredProfile(): any {

    const data = localStorage.getItem(this.PROFILE_KEY);

    if (!data) {
      return null;
    }

    try {
      return JSON.parse(data);
    } catch {
      localStorage.removeItem(this.PROFILE_KEY);
      return null;
    }
  }
  loadProfileAfterLogin(): void {

    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.loader.show();

    this.getKycProfile().subscribe({

      next: (res: any) => {

        this.loader.hide();
        this.isLoading = false;

        if (res?.status && res?.data) {

          this.profileSubject.next(res.data);

          localStorage.setItem(
            this.PROFILE_KEY,
            JSON.stringify(res.data)
          );

          console.log(
            'Fresh KYC Profile Loaded:',
            res.data
          );

          console.log(
            'Current Plan:',
            res.data?.master_user_plan?.master_plan_type?.planName
          );

        } else {

          this.profileSubject.next(null);

          localStorage.removeItem(this.PROFILE_KEY);

          this.toaster.error(
            res?.message || 'Unable to get KYC profile'
          );
        }
      },

      error: (error: any) => {

        this.loader.hide();
        this.isLoading = false;

        this.profileSubject.next(null);

        localStorage.removeItem(this.PROFILE_KEY);

        this.toaster.error(
          error?.error?.message || 'Something went wrong'
        );
      }
    });
  }
  // loadProfileAfterLogin(): void {
  //   if (this.profileSubject.value) {
  //     return;
  //   }
  //   if (this.isLoading) {
  //     return;
  //   }
  //   this.isLoading = true;
  //   this.loader.show();
  //   this.getKycProfile().subscribe({
  //     next: (res: any) => {
  //       this.loader.hide();
  //       this.isLoading = false;
  //       if (res?.status) {
  //         this.profileSubject.next(res.data);
  //         localStorage.setItem(
  //           this.PROFILE_KEY,
  //           JSON.stringify(res.data)
  //         );
  //       } else {
  //         this.toaster.error(
  //           res?.message || 'Unable to get KYC profile'
  //         );
  //       }
  //     },

  //     error: (error: any) => {
  //       this.loader.hide();
  //       this.isLoading = false;
  //       this.toaster.error(
  //         error?.error?.message || 'Something went wrong'
  //       );
  //     }
  //   });
  // }
  clearProfile(): void {

    localStorage.removeItem(this.PROFILE_KEY);

    this.profileSubject.next(null);
  }
  refreshProfile(): void {
    this.getKycProfile().subscribe({
      next: (res: any) => {
        if (res?.status) {
          this.profileSubject.next(res.data);

          localStorage.setItem(
            this.PROFILE_KEY,
            JSON.stringify(res.data)
          );
        }
      },
      error: (error: any) => {
        console.error('KYC Profile API error:', error);
      }
    });
  }
}

